











































import { exportData } from '@/api/export';
import BaseComponent from '@/components/BaseComponent';
import Button from '@/components/Button/Button.vue';
import DateInput from '@/components/DateInput/DateInput.vue';
import Dropdown from '@/components/Dropdown/Dropdown.vue';
import { miscTypes } from '@/store/modules/misc/miscTypes';
import { Ship } from '@/typing/api/ship.class';
import { getState } from '@/utils/vueInstance';
import Component from 'vue-class-component';

@Component({
  components: {
    DateInput,
    Button,
    Dropdown,
  },
})
export default class ReportExport extends BaseComponent {
  get ships(): Ship[] {
    return getState().project.projectData?.ships ?? [];
  }

  from = '';
  to = '';
  shipId: any = null;

  mounted(): void {
    this._genericInit(true);
    this._setPageName('Exporteren');

    if (this.isClient() || this.isContractor()) {
      if (this.isClient()) {
        this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
          label: 'Projecten',
          active: false,
          navPath: '/projects',
        });
      }
      this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
        label: 'Rapporten',
        active: false,
        navPath: '/reports',
      });
      this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
        label: 'Exporteren',
        active: true,
        navPath: '/export',
      });
      if (this.isClient()) {
        this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
          label: 'Beheer',
          active: false,
          navPath: '/manage',
        });
      }
    } else {
      this.$router.push('/');
    }
  }

  async startExport(): Promise<void> {
    const from = this.$dayjs(this.from, 'DD/MM/YYYY').utc(true);
    const to = this.$dayjs(this.to, 'DD/MM/YYYY').utc(true);
    const ship = getState().project.projectData?.ships.find(
      (x) => x.id === this.shipId
    );

    if (!ship) {
      return;
    }

    this.$store.dispatch(miscTypes.actions.TOGGLE_LOADER);
    await exportData(to.format(), from.format(), ship);
    this.$store.dispatch(miscTypes.actions.TOGGLE_LOADER);
  }
}
